import React, { useState } from "react";
import { Link } from "react-router-dom";

//Roles
import RoleGuard from "../auth/RoleGuard";
import { ROLE_GROUPS, MODULES, ROLES } from "../auth/roles";

/*React-Bootstrap components*/
import Nav from "react-bootstrap/Nav";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

/* React-icons*/
import { CgChevronDoubleLeft, CgChevronDoubleRight } from "react-icons/cg";
import {
  BsGrid3X3GapFill,
  BsPeopleFill,
  BsListOl,
  BsFillKanbanFill,
  BsGrid1X2Fill,
  BsCashCoin,
  BsSpeedometer2,
  BsBuilding,
  BsPersonLinesFill,
} from "react-icons/bs";
import { AiFillProfile, AiOutlineMenu, AiOutlineHistory } from "react-icons/ai";
import { FaUserTie } from "react-icons/fa";
import { HiDocumentReport } from "react-icons/hi";

const SidebarNavigation = ({ role }) => {
  const [menuSizeBig, setMenuSizeBig] = useState(true);
  const [menuSizeClass, setMenuSizeClass] = useState("sidebar-big");
  const [showHamburgerMenu, setShowHamburgerMenu] = useState("show-menu-none");

  const sidebarSizeChange = () => {
    if (menuSizeBig) {
      setMenuSizeBig(false);
      setMenuSizeClass("sidebar-small");
    } else {
      setMenuSizeBig(true);
      setMenuSizeClass("sidebar-big");
    }
  };

  const handleSidebar = () => {
    if (showHamburgerMenu === "show-menu-none") {
      setShowHamburgerMenu("show-menu-block");
      setMenuSizeBig(true);
      setMenuSizeClass("sidebar-big");
    } else {
      setShowHamburgerMenu("show-menu-none");
    }
  };

  return (
    <Col className={`sidebar ${menuSizeClass}`}>
      <Nav defaultActiveKey="/home" className="flex-column sidebar-column">
        <div className="mt-4 sidebar-column-hamburger">
          <Button onClick={handleSidebar}>
            <AiOutlineMenu className="sidebar-icon-hamburger " />
          </Button>
        </div>

        <div onClick={() => setShowHamburgerMenu("show-menu-none")}>
          <div className={showHamburgerMenu}>
            <div className="mt-4">
              <RoleGuard
                moduleKey={MODULES.AKTUALNI_RAZPISI}
                roles={ROLE_GROUPS.ALL}
              >
                <Nav.Link as={Link} to="/AktualniRazpisi" className="mb-3">
                  <BsGrid1X2Fill className="sidebar-icon" />
                  {menuSizeBig && <span>Aktualni razpisi</span>}
                </Nav.Link>
              </RoleGuard>
              <RoleGuard
                moduleKey={MODULES.PROGRAMI}
                roles={ROLE_GROUPS.GLOBALNI_AND_FAKULTETNI}
              >
                <Nav.Link as={Link} to="/Programi" className="mb-3">
                  <AiFillProfile className="sidebar-icon" />
                  {menuSizeBig && <span>Programi</span>}
                </Nav.Link>
              </RoleGuard>
              <RoleGuard
                moduleKey={MODULES.RAZPISI}
                roles={ROLE_GROUPS.GLOBALNI_AND_FAKULTETNI}
              >
                <Nav.Link
                  as={Link}
                  to="/Razpisi"
                  className="mb-3"
                  style={{ opacity: 0.4 }}
                >
                  <BsGrid3X3GapFill className="sidebar-icon" />
                  {menuSizeBig && <span>Razpisi</span>}
                </Nav.Link>
              </RoleGuard>
              <RoleGuard
                moduleKey={MODULES.RAZPISI}
                roles={ROLE_GROUPS.GLOBALNI_AND_FAKULTETNI}
              >
                <Nav.Link as={Link} to="/RazpisiV2" className="mb-3">
                  <BsGrid3X3GapFill className="sidebar-icon" />
                  {menuSizeBig && <span>Razpisi V2</span>}
                </Nav.Link>
              </RoleGuard>

              <RoleGuard moduleKey={MODULES.PROJEKTI} roles={ROLE_GROUPS.ALL}>
                <Nav.Link
                  as={Link}
                  to="/Projekti"
                  className="mb-3"
                  style={{ opacity: 0.4 }}
                >
                  <BsFillKanbanFill className="sidebar-icon" />
                  {menuSizeBig && <span>Projekti</span>}
                </Nav.Link>
              </RoleGuard>
              <RoleGuard moduleKey={MODULES.PROJEKTI} roles={ROLE_GROUPS.ALL}>
                <Nav.Link as={Link} to="/ProjektiV2" className="mb-3">
                  <BsFillKanbanFill className="sidebar-icon" />
                  {menuSizeBig && <span>Projekti V2</span>}
                </Nav.Link>
              </RoleGuard>
              <RoleGuard
                moduleKey={MODULES.PARTNERJI}
                roles={ROLE_GROUPS.GLOBALNI_AND_FAKULTETNI}
              >
                <Nav.Link
                  as={Link}
                  to="/ProjektniPartnerji"
                  className="mb-3"
                  style={{ opacity: 0.4 }}
                >
                  <FaUserTie className="sidebar-icon" />
                  {menuSizeBig && <span>Projektni partnerji</span>}
                </Nav.Link>
              </RoleGuard>
              <RoleGuard
                moduleKey={MODULES.PARTNERJI}
                roles={ROLE_GROUPS.GLOBALNI_AND_FAKULTETNI}
              >
                <Nav.Link as={Link} to="/ProjektniPartnerjiV2" className="mb-3">
                  <FaUserTie className="sidebar-icon" />
                  {menuSizeBig && <span>Partnerji V2</span>}
                </Nav.Link>
              </RoleGuard>

              <Nav.Link as={Link} to="/Partnerstva" className="mb-3">
                <BsBuilding className="sidebar-icon" />
                {menuSizeBig && <span>Partnerstva</span>}
              </Nav.Link>

              <Nav.Link as={Link} to="/KontaktiUM" className="mb-3">
                <BsPersonLinesFill className="sidebar-icon" />
                {menuSizeBig && <span>Kontakti UM</span>}
              </Nav.Link>



              <RoleGuard moduleKey={MODULES.DEMINIMIS} roles={ROLE_GROUPS.ALL}>
                <Nav.Link as={Link} to="/Deminimis" className="mb-3">
                  <BsCashCoin className="sidebar-icon" />
                  {menuSizeBig && <span>De minimis</span>}
                </Nav.Link>
              </RoleGuard>


              <RoleGuard
                moduleKey={MODULES.IZPISI_CLANICE}
                roles={ROLE_GROUPS.GLOBALNI_ADMINISTRATOR_AND_SKRBNIK}
              >
                <Nav.Link as={Link} to="/izpisiClanice" className="mb-3">
                  <HiDocumentReport className="sidebar-icon" />
                  {menuSizeBig && <span>Izpisi članice</span>}
                </Nav.Link>
              </RoleGuard>
              <RoleGuard
                moduleKey={MODULES.IZPISI}
                roles={[ROLES.GLOBALNI_ADMINISTRATOR]}
              >
                <Nav.Link as={Link} to="/izpisi" className="mb-3">
                  <HiDocumentReport className="sidebar-icon" />
                  {menuSizeBig && <span>Izpisi</span>}
                </Nav.Link>
              </RoleGuard>

              <RoleGuard
                moduleKey={MODULES.AVTORIZACIJE}
                roles={[ROLES.GLOBALNI_ADMINISTRATOR]}
              >
                <Nav.Link as={Link} to="/Avtorizacije" className="mb-3">
                  <BsPeopleFill className="sidebar-icon" />
                  {menuSizeBig && <span>Avtorizacije</span>}
                </Nav.Link>
              </RoleGuard>
              <RoleGuard
                moduleKey={MODULES.SIFRANTI}
                roles={ROLE_GROUPS.GLOBALNI}
              >
                <Nav.Link as={Link} to="/Sifranti" className="mb-3">
                  <BsListOl className="sidebar-icon" />
                  {menuSizeBig && <span>Šifranti</span>}
                </Nav.Link>
              </RoleGuard>

              <RoleGuard
                moduleKey={MODULES.REVIZIJSKA_SLED}
                roles={[ROLES.GLOBALNI_ADMINISTRATOR]}
              >
                <Nav.Link as={Link} to="/Zgodovina-sprememb" className="mb-3">
                  <AiOutlineHistory className="sidebar-icon" />
                  {menuSizeBig && <span>Zgodovina sprememb</span>}
                </Nav.Link>
              </RoleGuard>
            </div>
          </div>
        </div>
        <div className="arrow-hamburger-menu__hidden">
          <div className={showHamburgerMenu}>
            <div className="text-center mb-3">
              {menuSizeBig && (
                <CgChevronDoubleLeft
                  className="sidebar-icon-bottom"
                  onClick={sidebarSizeChange}
                />
              )}

              {!menuSizeBig && (
                <CgChevronDoubleRight
                  className="sidebar-icon-bottom"
                  onClick={sidebarSizeChange}
                />
              )}
            </div>
          </div>
        </div>
      </Nav>
    </Col>
  );
};

export default SidebarNavigation;
